import React, { useState } from 'react';
import { theme } from '../../theme';

interface UpgradeToOwnerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpgrade: () => Promise<void>;
}

const UpgradeToOwnerModal: React.FC<UpgradeToOwnerModalProps> = ({
  isOpen,
  onClose,
  onUpgrade
}) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleUpgrade = async () => {
    setLoading(true);
    try {
      await onUpgrade();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error upgrading to owner:', error);
    } finally {
      setLoading(false);
    }
  };

  const benefits = [
    'Gestionar complejos deportivos',
    'Administrar múltiples canchas',
    'Ver y confirmar reservas',
    'Acceder a estadísticas de tus canchas'
  ];

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000,
      padding: '16px'
    }}>
      <div style={{
        backgroundColor: theme.colors.surface,
        borderRadius: '18px',
        padding: '48px',
        maxWidth: '500px',
        width: '100%',
        position: 'relative',
        border: `2px solid ${theme.colors.border}`,
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)'
      }}>
        {/* Close button */}
        <button
          onClick={onClose}
          disabled={loading}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: 'none',
            border: 'none',
            color: theme.colors.textSecondary,
            cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: '28px',
            padding: '4px',
            opacity: loading ? 0.5 : 1,
            transition: 'all 0.2s ease'
          }}
        >
          ✕
        </button>

        {/* Icon */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ fontSize: '80px', marginBottom: '16px' }}>🏟️</div>
        </div>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '32px',
            fontWeight: 700,
            color: theme.colors.text,
            margin: '0 0 12px 0',
            fontFamily: theme.fonts.heading
          }}>
            Funciones de Propietario
          </h2>
          <p style={{
            color: theme.colors.textSecondary,
            fontSize: '16px',
            margin: '0 0 8px 0',
            lineHeight: 1.5,
            fontFamily: theme.fonts.body
          }}>
            Esta sección es para propietarios de canchas o complejos deportivos.
          </p>
          <p style={{
            color: theme.colors.text,
            fontSize: '18px',
            fontWeight: 600,
            margin: 0,
            fontFamily: theme.fonts.body
          }}>
            ¿Querés habilitar estas funciones?
          </p>
        </div>

        {/* Benefits */}
        <div style={{
          backgroundColor: theme.colors.card,
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '32px',
          border: `1px solid ${theme.colors.border}`
        }}>
          {benefits.map((benefit, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: index < benefits.length - 1 ? '16px' : 0
              }}
            >
              <div style={{
                fontSize: '20px',
                color: theme.colors.primary,
                fontWeight: 'bold'
              }}>
                ✓
              </div>
              <span style={{
                fontSize: '15px',
                color: theme.colors.text,
                fontFamily: theme.fonts.body
              }}>
                {benefit}
              </span>
            </div>
          ))}
        </div>

        {/* Buttons */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '16px'
        }}>
          <button
            onClick={handleUpgrade}
            disabled={loading}
            style={{
              padding: '16px 24px',
              backgroundColor: theme.colors.primary,
              color: theme.colors.background,
              border: 'none',
              borderRadius: theme.borderRadius.button,
              fontSize: '16px',
              fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: theme.fonts.heading,
              letterSpacing: '0.5px',
              opacity: loading ? 0.6 : 1,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.currentTarget.style.backgroundColor = '#00cc66';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.currentTarget.style.backgroundColor = theme.colors.primary;
              }
            }}
          >
            {loading ? 'HABILITANDO...' : 'SÍ, HABILITAR'}
          </button>

          <button
            onClick={onClose}
            disabled={loading}
            style={{
              padding: '16px 24px',
              backgroundColor: 'transparent',
              color: theme.colors.textSecondary,
              border: `2px solid ${theme.colors.border}`,
              borderRadius: theme.borderRadius.button,
              fontSize: '16px',
              fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: theme.fonts.heading,
              letterSpacing: '0.5px',
              opacity: loading ? 0.5 : 1,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.currentTarget.style.borderColor = theme.colors.textSecondary;
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.currentTarget.style.borderColor = theme.colors.border;
              }
            }}
          >
            NO, VOLVER
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeToOwnerModal;
